import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MainserviceService } from '../service/mainservice.service';
import { NotificationMaster } from '../model/NotificationMaster.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { AuthService } from '../service/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  noticationMaster:NotificationMaster= new NotificationMaster();
  studentMaster:StudentMaster = new StudentMaster();
  notificationList:NotificationMaster[]=[];
  constructor(private mainService:MainserviceService, private authService:AuthService,public spinnerService: NgxSpinnerService
  ) { }



  ngOnInit() {
    this.spinnerService.show()
    this.studentMaster= this.authService.getUserSession();
    this.getNotification();
  }
  getNotification(){
    this.noticationMaster.toUserId = this.studentMaster.user.id;
    // this.noticationMaster.toUser.id = this.studentMaster.studentMasterId;
    this.noticationMaster.type='NOTIFICATION'
    this.mainService.getNotification(this.noticationMaster).subscribe(data=>{
     this.notificationList= data;
     this.spinnerService.hide()
      //  this.router.navigateByUrl('/');
    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        //json circular break at server side always add
            //extra information of timestamp and status along with
            //main json so parsing occurs still at status 200
          
        
            
  
          //  this.redirection();
      }
    })
  }

}
